// extracted by mini-css-extract-plugin
export default {"root":"FormCheckbox_root__CbnIW"};